import angular from 'angular';
import stringToNumberDirective from './string-to-number.directive';

export default angular.module('app.components.global.stringToNumber', [])
  .directive('stringToNumber', stringToNumberDirective)
  .name;

console.log('app.components.global.stringToNumber created');
